<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :get-data-func="getTeachers"
      :headers="headers"
      :filter-items="filterItems"
      :must-sort="false"
      @click:row="goDetails($event.item)"
      clickable
      item-key="code"
      search-text="搜索姓名"
      title-text="教职工列表"
    ></l-data-table>
  </l-layout>
</template>

<script>
export default {
  name: 'TeacherList',
  data () {
    return {
      headers: [
        {text: '姓名', value: 'name', align: 'left', placeholder: 'N/A', sortable: false},
        {text: '工号', value: 'code', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '单位', value: 'orgName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '状态', value: 'statusName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '更新时间', value: 'updateTime', align: 'right', placeholder: 'N/A', sortable: false},
      ],
      filterItems:[
        {
          prependIcon: '$vuetify.icons.person',
          key: 'loginId',
          value: '',
          label: '教工号',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
    }
  },
  methods: {
    async getTeachers ({pagination, search,filterItems}) {
      return this.$store.dispatch('mva/getTeachers', {
        pagination,
        search: {name: {keyword: search}},
        filterItems
      })
    },
    goDetails (item, force = false) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'TeacherDetails',
          params: {name: item.name},
          query: {code: item.code}
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
